export const selectFlags = (state) => state.flags?.data || {};

export const selectBillogramEnabled = (state) =>
  Boolean(selectFlags(state).ENABLE_BILLOGRAM_INVOICES);

export const selectStripeCheckoutEnabled = (state) =>
  Boolean(selectFlags(state).ENABLE_STRIPE_CHECKOUT);

export const selectFlagsLoading = (state) => Boolean(state.flags?.loading);
export const selectFlagsError = (state) => state.flags?.error || null;
